import JumpcloudGoApi from 'api/v2/JumpcloudGoApi';
import Vue from 'vue';

export const SET_FEATURE_SETTINGS = 'SET_FEATURE_SETTINGS';
export const SET_FEATURE_ENABLED = 'SET_FEATURE_ENABLED';
export const SET_POLICIES = 'SET_POLICIES';

const initialState = () => ({
  settings: {},
  isFeatureEnabled: false,
  policies: {},
});

export const createJumpcloudGoModule = () => ({
  namespaced: true,
  state: initialState(),
  actions: {
    fetchPolicies({ commit }) {
      return JumpcloudGoApi.fetchPolicies().then((policies) => {
        commit(SET_POLICIES, policies);
      }).catch((error) => {
        throw error;
      });
    },
    fetchSettings({ commit }) {
      return JumpcloudGoApi.fetch().then((settings) => {
        commit(SET_FEATURE_SETTINGS, settings);
        commit(SET_FEATURE_ENABLED, settings.enabled);
      }).catch((error) => {
        throw error;
      });
    },
    updateSettings({ commit }, settings) {
      return JumpcloudGoApi.update(settings).then(() => {
        commit(SET_FEATURE_ENABLED, settings.enabled);
      }).catch((error) => {
        throw error;
      });
    },
  },
  mutations: {
    [SET_FEATURE_SETTINGS]: (state, settings) => {
      Vue.set(state, 'settings', settings);
    },
    [SET_FEATURE_ENABLED]: (state, enabled) => {
      Vue.set(state, 'isFeatureEnabled', enabled);
    },
    [SET_POLICIES]: (state, policies) => {
      Vue.set(state, 'policies', policies);
    },
  },
  getters: {
    getFeatureSettings(state) {
      return state.settings;
    },
    getFeatureEnabled(state) {
      return state.isFeatureEnabled;
    },
    getPolicies(state) {
      return state.policies;
    },
  },
});

export default createJumpcloudGoModule();
